
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.46 39.08a2 2 0 112-2 2 2 0 01-2 2zm4.85-4.86a2 2 0 112-2 2 2 0 01-2 2zm4.86-4.86a2 2 0 112-2 2 2 0 01-2 2zM27 24.5a2 2 0 112-2 2 2 0 01-2 2zm4.86-4.86a2 2 0 112-2 2 2 0 01-1.97 2zM37.54 15a2 2 0 112-2 2 2 0 01-2 2z","fill":"#515358"}}),_c('circle',{attrs:{"cx":"24.89","cy":"24.89","r":"23.6","fill":"none","stroke":"#515358","stroke-miterlimit":"10","stroke-width":"1.2"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/infra.svg